"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
const core_1 = require("@angular/core");
/** Some pricing/cost we save with some without VAT.
 * To make it easier to onput the values, we offer to both
 * input them with or without VAT and calculate the other one.
 * We only save the value we need.
 */
let PricingComponent = class PricingComponent {
    constructor() {
        this.calculation = {
            purchasePriceVat: undefined,
            retailManufacturerVat: undefined,
            retailInvoiceVat: undefined,
            retailOfferVat: undefined,
            campaignPriceWithoutVat: undefined,
            onlinePriceWithoutVat: undefined,
            dealerPriceWithVat: undefined,
        };
        this.calculateVat = (value, includeVat, vatRate) => {
            const calc = includeVat
                ? value * (1 + (vatRate || 0.19))
                : value / (1 + (vatRate || 0.19));
            return Number(calc.toFixed(2));
        };
        this.calculatePrice = (withVat, price) => {
            const { includesVat, vatRate } = this.price;
            if (!includesVat || !vatRate || !price)
                return 0;
            return this.calculateVat(price, withVat, vatRate);
        };
    }
    ngOnInit() {
        this.calculation.purchasePriceVat = this.calculatePrice(true, this.costs.purchasePrice);
        this.calculation.retailManufacturerVat = this.calculatePrice(true, this.price.retailPrices.manufacturer);
        this.calculation.retailInvoiceVat = this.calculatePrice(true, this.price.retailPrices.invoice);
        this.calculation.retailOfferVat = this.calculatePrice(true, this.price.retailPrices.offer);
        this.calculation.campaignPriceWithoutVat = this.calculatePrice(false, this.price.campaignPrice);
        this.calculation.onlinePriceWithoutVat = this.calculatePrice(false, this.price.onlinePrice);
        this.calculation.dealerPriceWithVat = this.calculatePrice(true, this.price.dealerPrice);
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], PricingComponent.prototype, "price", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], PricingComponent.prototype, "costs", void 0);
PricingComponent = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-pricing-form',
        templateUrl: require('./pricing.component.html'),
    })
], PricingComponent);
exports.default = PricingComponent;
